customElements.define('component-lob-registration', class LobRegistration extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Get DIS key
    this.disServiceKey = JSON.parse(this.getAttribute('data-pskey')).disServiceKey;
    this.cryptoSecret = this.getAttribute('data-crypto-secret');

    // DOM elements
    const countrySelector = document.querySelector('#country');
    const selectedCountry = countrySelector.options[countrySelector.selectedIndex];
    const provinces = selectedCountry.dataset.provinces;
    const provinceSelectTag = document.querySelector('#province');
    const fragment = document.createDocumentFragment();
    const emailParam = this.getParameterByName('email');

    // Init
    this.email = '';
    JSON.parse(provinces).forEach((province) => {
      const option = document.createElement('option');
      [option.value, option.text] = province;
      fragment.appendChild(option);
    });
    provinceSelectTag.appendChild(fragment);

    if (emailParam) {
      this.email = emailParam;
      document.querySelector('#dm-email').value = emailParam;
    }

    // Event handlers
    document.querySelector('.js-registration-form').addEventListener('submit', (e) => {
      e.preventDefault();
      this.onSubmit();
    });
  }

  onSubmit() {
    const buttonSelector = document.querySelector('.js-submit-button');
    const registration = document.querySelector('.js-registration-form');
    const formElements = [...registration.querySelectorAll('input[type="text"], select')];
    const fields = {};

    buttonSelector.disabled = true;
    formElements.forEach((el) => {
      fields[el.name] = el.value;
    });

    this.email = document.querySelector('#dm-email').value;

    // Identify user on Klaviyo
    window.klaviyoIdentify && window.klaviyoIdentify(this.email);

    const isOptin = document.querySelector('input[name="dm_optin"]:checked').value === 'true';

    const {
      firstName,
      lastName,
      address1,
      address2,
      city,
      state,
      zipCode,
    } = fields;

    const disClientData = {
      event: 'Direct Mail Preferences Update',
      email: this.email,
      topic: 'Catalogs & Mailers Update',
      fields: {
        direct_mail_opt_in: isOptin,
        event_direct_mail_opt_in_date: isOptin ? new Date() : null,
        event_direct_mail_opt_out_date: isOptin ? null : new Date(),
        firstName,
        lastName,
        address1,
        address2,
        city,
        state,
        zipCode,
      },
    };

    this.directMailSubscriptionUpdate(disClientData)
      .then(() => {
        if (isOptin) {
          this.sendEmailSubscribeGTMEvent();
        }
        document.querySelector('.js-message').classList.remove('mail-registration__message--hidden');
        buttonSelector.disabled = false;
      })
      .catch((error) => {
        console.error('Fail to call disClient', error);
      });
  };
  sendEmailSubscribeGTMEvent() {
    const cipherInstance = browserCrypto.createCipher(
      'aes-256-cbc',
      this.cryptoSecret,
    );

    const encryptedEmail = cipherInstance.update(this.email, 'utf8', 'hex');
    const finalEmailHash = encryptedEmail + cipherInstance.final('hex');

    window.sendGTMData && window.sendGTMData({
      event: 'email_subscribe',
      email: finalEmailHash,
      source: 'direct_mail'
    });
  }

  directMailSubscriptionUpdate(payload) {
    const url = window.location.hostname.includes('trythirdlove.com') ?
      'https://dis-apis.trythirdlove.com/v0/DirectMailSubscriptionUpdates' :
      'https://dis-apis.thirdlove.com/v0/DirectMailSubscriptionUpdates';

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': this.disServiceKey
      },
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }

  getParameterByName(name) {
    const formattedName = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp(`[\\?&]${formattedName}=([^&#]*)`, 'i');
    const results = regex.exec(document.location.search);

    return results == null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }
});
